<template>
    <component
        v-bind:is="href ? 'a' : 'button'"
        v-bind:href="href"
        v-bind:type="href ? null : 'submit'"
        v-bind:class="{'btn-loading': loading, 'disabled': href && loading}"
        v-bind:aria-disabled="href && loading ? 'true' : null"
        v-on:click="onClick"
        class="btn btn-primary"
    >
        {{ label }}
        <div v-if="loading" class="loader">
            <div class="chartdonut chartdonut_animation--rotate-tiny chartdonut--tiny">
                <svg class="i-stroke-bright" width="24" height="24"><g><circle class="icon" cx="50%" cy="50%" r="10" stroke-width="2" fill="none" stroke-dashoffset="5"></circle></g></svg>
            </div>
        </div>
    </component>
</template>
<script>
    export default {
        props: {
            label: {
                type: String,
                required: true
            },
            href: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                loading: false
            }
        },
        mounted() {
            window.addEventListener('pageshow', this.onPageShow);
        },
        beforeDestroy() {
            window.removeEventListener('pageshow', this.onPageShow);
        },
        methods: {
            onClick(event) {
                if (this.href && this.loading) {
                    event.preventDefault();

                    return;
                }

                this.loading = true;
            },
            onPageShow(event) {
                if (event.persisted) {
                    this.loading = false;
                }
            }
        }
    }
</script>
